{
  "brand": {
    "name": "Trump Post Alert"
  },
  "header": {
    "title": "Trump Post Alert Login",
    "subtitle": {
      "signIn": "Sign in with your Trump Post Alert account to continue.",
      "signUp": "Create your Trump Post Alert account in a few seconds."
    }
  },
  "form": {
    "email": {
      "label": "Email address",
      "errors": {
        "required": "Please enter your email address.",
        "email": "This email address is invalid."
      }
    },
    "password": {
      "label": "Password",
      "errors": {
        "required": "Please enter your password.",
        "minLength": "Password must be at least 8 characters long."
      }
    },
    "confirmPassword": {
      "label": "Confirm password",
      "errors": {
        "required": "Please confirm your password.",
        "mismatch": "Passwords do not match."
      }
    }
  },
  "actions": {
    "submit": {
      "signIn": "Sign in",
      "signUp": "Create account"
    },
    "modeSwitch": {
      "signIn": "Sign in now",
      "signUp": "Create account",
      "prefixSignIn": "Don't have an account?",
      "prefixSignUp": "Already registered?"
    },
    "providers": {
      "sectionSignIn": "or continue with",
      "sectionSignUp": "or sign up with"
    }
  },
  "providers": {
    "google": "Google",
    "facebook": "Facebook",
    "apple": "Apple"
  },
  "accountSetup": {
    "title": "Complete your profile",
    "intro": {
      "create": "We just need a few more details to finish setting up your account.",
      "update": "Please review and update your profile details before continuing."
    },
    "fields": {
      "salutation": "Salutation",
      "firstName": "First name",
      "lastName": "Last name",
      "username": "Username",
      "language": "Preferred language"
    },
    "salutation": {
      "options": {
        "male": "Mr.",
        "female": "Ms.",
        "diverse": "Mx."
      }
    },
    "language": {
      "auto": "Keep current language"
    },
    "actions": {
      "create": "Save and continue",
      "save": "Save and continue"
    },
    "errors": {
      "salutationRequired": "Please choose how we should address you.",
      "firstNameRequired": "Please enter your first name.",
      "firstNameTooLong": "First name must be at most 100 characters long.",
      "lastNameRequired": "Please enter your last name.",
      "lastNameTooLong": "Last name must be at most 100 characters long.",
      "usernameRequired": "Please choose a username.",
      "usernameInvalid": "Usernames can contain letters, numbers, dots, underscores, or hyphens only.",
      "usernameExists": "This username is already taken.",
      "validationFailed": "Please review the highlighted fields and try again.",
      "profileMissing": "We couldn't find your profile. Please sign in again.",
      "generic": "We couldn't save your profile. Please try again."
    }
  },
  "languages": {
    "en": "English",
    "de": "German",
    "fr": "French",
    "es": "Spanish",
    "ja": "Japanese",
    "it": "Italian"
  },
  "footer": {
    "agreementPrefix": "By continuing you agree to the ",
    "termsLink": "Terms of Use",
    "connector": " and the ",
    "privacyLink": "Privacy Policy",
    "suffix": "."
  },
  "errors": {
    "firebase": {
      "invalidEmail": "Please check your email address.",
      "userDisabled": "This account has been disabled. Please contact support.",
      "invalidCredentials": "Email or password is incorrect.",
      "emailAlreadyInUse": "An account with this email already exists. Please sign in.",
      "weakPassword": "The password is too weak. Choose a stronger password with at least 8 characters.",
      "operationNotAllowed": "Email and password sign-up is currently disabled. Please contact support.",
      "popupClosed": "Sign-in was cancelled.",
      "popupCancelled": "A sign-in is already in progress. Please close existing pop-ups.",
      "popupBlocked": "The pop-up was blocked. Please allow pop-ups for this site.",
      "genericSignIn": "Sign-in failed. Please try again.",
      "genericSignUp": "Registration failed. Please try again."
    }
  }
}
